(() => {
  const bind = (root) => {
    if (root.dataset.peGoogleBound === 'true') return;
    root.dataset.peGoogleBound = 'true';
    const load = root.querySelector('[data-pe-google-load]');
    const close = root.querySelector('[data-pe-google-close]');
    const frame = root.querySelector('[data-pe-google-frame]');
    if (!load || !close || !frame) return;
    load.addEventListener('click', () => {
      const src = root.dataset.embedSrc;
      if (!src || !src.startsWith('https://www.google.com/maps/embed?')) return;
      const iframe = document.createElement('iframe');
      iframe.title = root.querySelector('h2').textContent;
      iframe.src = src;
      iframe.loading = 'lazy';
      iframe.referrerPolicy = 'strict-origin-when-cross-origin';
      iframe.allowFullscreen = true;
      frame.replaceChildren(iframe);
      frame.hidden = false;
      load.hidden = true;
      close.hidden = false;
      load.setAttribute('aria-expanded', 'true');
    });
    close.addEventListener('click', () => {
      frame.replaceChildren();
      frame.hidden = true;
      close.hidden = true;
      load.hidden = false;
      load.setAttribute('aria-expanded', 'false');
      load.focus();
    });
  };
  document.querySelectorAll('[data-pe-google-profile]').forEach(bind);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-pe-google-profile]').forEach(bind);
  });
})();
